import { Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import ArtistPage from 'commons/ArtistPage';
import TabPanel from 'commons/TabPanel';
import { SHARE_TYPE } from 'configs/Constant';

import ArtworkCollection from '../ArtworkCollection';
import GalleryArtist from '../GalleryArtist';
import GalleryArtwork from '../GalleryArtwork';
import GalleryExhibition from '../GalleryExhibition';

const PublicShareTabContent = ({
  classes,
  tabValue,
  handleTabChange,
  getLabel,
  shareType,
  isCollectorPublic,
  isArtist,
  userProfile,
  userUuid,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();

  const isArtworkOnly = shareType === SHARE_TYPE.ARTWORK;

  return (
    <>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        className={classes.tabs}
      >
        <Tab
          label={getLabel({
            text: t('all_works'),
            number: '',
          })}
          value={1}
          className={classes.tab}
        />
        {!isArtworkOnly && isCollectorPublic && (
          <Tab
            label={getLabel({
              text: t('artists'),
              number: '',
            })}
            value={2}
            className={classes.tab}
          />
        )}
        {!isArtworkOnly && (
          <Tab
            label={getLabel({
              text: t('collection'),
              number: '',
            })}
            value={3}
            className={classes.tab}
          />
        )}
        {!isArtworkOnly && isArtist && (
          <Tab
            label={t('artist_profile')}
            value={4}
            className={classes.tab}
          />
        )}
        {!isArtworkOnly && (
          <Tab
            label={getLabel({
              text: t('exhibitions'),
              number: '',
            })}
            value={5}
            className={classes.tab}
          />
        )}
      </Tabs>

      <TabPanel
        value={tabValue}
        index={1}
      >
        <GalleryArtwork
          isOwner={false}
          isPublicShare
        />
      </TabPanel>

      {!isArtworkOnly && isArtist && (
        <TabPanel
          value={tabValue}
          index={4}
        >
          <ArtistPage
            userProfile={userProfile}
            artistUuid={id}
            isPublicShare
          />
        </TabPanel>
      )}

      {!isArtworkOnly && isCollectorPublic && (
        <TabPanel
          value={tabValue}
          index={2}
        >
          <GalleryArtist
            userUuid={userUuid}
            userProfile={userProfile}
            isPublicShare
          />
        </TabPanel>
      )}

      {!isArtworkOnly && (
        <TabPanel
          value={tabValue}
          index={3}
        >
          <ArtworkCollection
            isOwner={false}
            isPublicShare
          />
        </TabPanel>
      )}

      {!isArtworkOnly && (
        <TabPanel
          value={tabValue}
          index={5}
        >
          <GalleryExhibition
            isOwner={false}
            isPublicShare
            userUuid={userUuid}
          />
        </TabPanel>
      )}
    </>
  );
};

export default PublicShareTabContent;
